<template>
    <div class="home-page">
        <h1>Salut!</h1>
        <p>Începe prin a căuta un produs, utilizând bara de căutare.</p>
    </div>
</template>

<script>

  export default {
    name: 'Home',
  }
</script>

<style scoped>
    .home-page {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        color: grey;
        padding: 20px;
        text-align: center;
    }

    h1 {
        font-size: 7rem;
    }

    p {
        font-size: 2rem;
    }
</style>
